import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IAlertcondition,
  IAlertconditionListRequest,
  IAlertconditionCreateRequest,
  IAlertconditionUpdateRequest,
  AlertconditionState,
} from "@/types/alertcondition";
import CustomRequest from "../customRequest";

const actions: ActionTree<AlertconditionState, RootState> = {
  async salesGetList({ commit }, params: IAlertconditionListRequest) {
    await CustomRequest.get<IPagination<IAlertcondition>>({
      uri: "/sales/alertcondition",
      params,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, alertconditionId: number) {
    await CustomRequest.get<IAlertcondition>({
      uri: `/sales/alertcondition/${alertconditionId}`,
      commit,
      target: "single",
    });
  },

  async salesUpdate(
    { commit },
    datas: { alertcondition_id: number; params: IAlertconditionUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IAlertcondition>({
      uri: `/sales/alertcondition/${datas.alertcondition_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: IAlertconditionCreateRequest) {
    const { error } = await CustomRequest.post<IAlertcondition>({
      uri: `/sales/alertcondition/`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, alertcondition_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/alertcondition/${alertcondition_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
